import Home from "wallet/views/index.vue";
import Assets from "wallet/views/wallet.vue";

const routes = [
  {
    path: "/",
    name: "index",
    component: Home
  },
  {
    path: "/assets",
    name: "wallet",
    component: Assets
  },
  {
    path: "/addresses/:id",
    name: "addresses-id",
    component: () => import("wallet/views/addresses/_id/index.vue")
  },
  {
    path: "/addresses/:id/create",
    name: "addresses-id-create",
    component: () => import("wallet/views/addresses/_id/create.vue")
  },
  {
    path: "/addresses/:id/edit",
    name: "addresses-id-edit",
    component: () => import("wallet/views/addresses/_id/edit.vue")
  },
  {
    path: "/withdraw/address/:id",
    name: "withdraw-address",
    component: () => import("wallet/views/withdraw/address.vue")
  },
  {
    path: "/withdraw/contact/:id",
    name: "withdraw-contact",
    component: () => import("wallet/views/withdraw/contact.vue")
  },
  {
    path: "/withdraw/result",
    name: "withdraw-result",
    component: () => import("wallet/views/withdraw/result.vue")
  },
  {
    path: "/deposit",
    name: "deposit",
    component: () => import("wallet/views/deposit.vue")
  },
  {
    path: "/snapshots/:id",
    name: "snapshots-id",
    component: () => import("wallet/views/snapshots/_id.vue")
  },
  {
    path: "/transaction/:id",
    name: "transaction-id",
    component: () => import("wallet/views/transaction/_id.vue")
  }
];

export default routes;
